<script>
import { counterMixin } from '@mixins/counter-mixin';
export default {
  components: {},
  props: {
    set: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  mixins: [counterMixin],
  data() {
    return {};
  },
  computed: {
    formattedTimeInfo() {
      return this.set.reps > 1
        ? `${this.set.reps} reps within  ${this.timeInMinutes(this.set.time)}`
        : `${this.timeInMinutes(this.set.time)}`;
    },
    formattedWeightInfo() {
      return this.set.reps > 1 ? `${this.set.weight} lbs for  ${this.set.reps} reps` : `${this.set.weight} lbs`;
    },
  },
  mounted() {},
  methods: {
    formattedTime(time) {
      return this.$_getFormattedSeconds(time);
    },
    timeInMinutes(num) {
      const seconds = num % 60;
      const minutes = Math.floor(num / 60);
      if (minutes >= 1) {
        if (seconds === 0) {
          return `${minutes} minutes`;
        }
        return `${minutes} minutes and ${seconds} seconds`;
      }
      return `${seconds} seconds`;
    },
    isAchieved(target, current) {
      return target === current;
    },
  },
};
</script>

<template>
  <div class="exercise-set-detail-counters">
    <div class="row">
      <div class="col">
        <div :class="['rep-counter']">
          <div class="rep-controls">
            <h1 class="rep-num"
              >{{ set.reps
              }}<small
                v-if="set.clientReps"
                class="result"
                :style="`color: ${isAchieved(set.reps, set.clientReps) ? '#447ee2' : '#DC3333'}`"
                >{{ set.clientReps }}</small
              ></h1
            >
          </div>
        </div>
      </div>
      <div class="col">
        <div :class="['rep-counter']">
          <div class="rep-controls">
            <h1 class="rep-num"
              >{{ formattedTime(set.time)
              }}<small
                v-if="set.clientTime"
                class="result"
                :style="`color: ${isAchieved(set.time, set.clientTime) ? '#447ee2' : '#DC3333'}`"
                >{{ formattedTime(set.clientTime) }}</small
              ></h1
            >
          </div>
        </div>
      </div>
      <div class="col">
        <div :class="['rep-counter']">
          <div class="rep-controls">
            <h1 class="rep-num"
              >{{ set.weight }}<small>LBS</small
              ><small
                v-if="set.clientWeight"
                class="result"
                :style="`color: ${isAchieved(set.weight, set.clientWeight) ? '#447ee2' : '#DC3333'}`"
                >{{ set.clientWeight }}</small
              ></h1
            >
          </div>
        </div>
      </div>
      <div class="col">
        <div :class="['rep-counter']">
          <div class="rep-controls">
            <h1 class="rep-num"
              >{{ formattedTime(set.afterSetRest)
              }}<small
                v-if="set.clientAfterSetRest"
                class="result"
                :style="`color: ${isAchieved(set.afterSetRest, set.clientAfterSetRest) ? '#447ee2' : '#DC3333'}`"
                >{{ formattedTime(set.clientAfterSetRest) }}</small
              ></h1
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if="set.weight" class="info">
      <BaseIcon class="icon-info-circle" name="info-circle" />
      {{ formattedWeightInfo }}
    </div>
    <div v-if="set.time && !set.weight" class="info">
      <BaseIcon class="icon-info-circle" name="info-circle" />
      {{ formattedTimeInfo }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.exercise-set-detail-counters {
  padding: 1.6rem 0;

  &:not(:first-of-type) {
    border-top: 1px solid $color-light-gray;
  }
}
.info {
  color: $color-text;
  font-family: $base-font-family;
  font-size: 1.2rem;
  letter-spacing: 0.116667px;
  line-height: 1.6rem;
}
.rep-counter {
  @extend %exercise-counter;

  .section-title {
    color: $color-text;
  }

  .rep-controls {
    @extend %exercise-counter-controls;

    .rep-num {
      color: $color-tag-text;
      font-family: $base-font-family;
      font-size: 2.1rem !important;
      font-weight: 600;
      margin: 0 2rem;
      .result {
        font-size: 70%;
        font-weight: 600;
      }

      small {
        font-size: 60%;
        font-weight: 400;
        margin-left: 6px;
        margin-right: 0.5rem;
      }
    }

    .rep-icon-wrapper {
      @extend %exercise-counter-icons;

      .icon-minus,
      .icon-plus {
        color: $color-text;
      }
    }
  }
}
</style>
